import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../data/services";
import { Eyebrow, FadeUp, MaskedLines } from "../site/Reveal";

const SPANS = ["lg:col-span-7", "lg:col-span-5", "lg:col-span-4", "lg:col-span-4", "lg:col-span-4", "lg:col-span-12"];

const Card = ({ s, i }) => {
  const Icon = s.icon;
  const withImage = i === 0 || i === 1 || i === 5;
  const wide = i === 5;
  return (
    <FadeUp delay={(i % 3) * 0.08} className="h-full">
      <Link to={`/services/${s.slug}`} data-testid={`bento-card-${s.slug}`}
        className={`group relative flex h-full overflow-hidden rounded-[22px] border border-[#0A192F]/12 bg-white ${wide ? "flex-col md:flex-row min-h-[320px]" : "flex-col min-h-[340px]"}`}>
        {withImage && (
          <div className={`relative overflow-hidden ${wide ? "md:w-1/2 h-56 md:h-auto" : "h-56"}`}>
            <img src={s.image} alt={s.title} className="absolute inset-0 h-full w-full object-cover scale-105 transition-transform duration-[1.4s] ease-out group-hover:scale-110" />
            <div className="absolute inset-0 bg-[#070F1E]/35 mix-blend-multiply" />
          </div>
        )}
        <div className={`relative flex flex-1 flex-col justify-between p-7 sm:p-9 ${wide ? "bg-[#0A192F] text-[#F4EEE3]" : ""}`}>
          <div className="flex items-start justify-between gap-6">
            <span className={`font-mono text-xs tracking-[0.25em] ${wide ? "text-[#D9BD7E]" : "text-[#8A6A2B]"}`}>{s.no} / 06</span>
            <span className={`grid h-12 w-12 place-items-center rounded-full border transition-[background-color,color,transform] duration-500 group-hover:rotate-45 ${wide ? "border-[#C5A059]/50 text-[#E3C88A] group-hover:bg-[#C5A059] group-hover:text-[#070F1E]" : "border-[#0A192F]/20 text-[#0A192F] group-hover:bg-[#0A192F] group-hover:text-[#F4EEE3]"}`}>
              <ArrowUpRight className="h-5 w-5" />
            </span>
          </div>
          <div className="mt-10">
            {!withImage && <Icon className="h-8 w-8 text-[#8A6A2B] mb-6" strokeWidth={1.3} />}
            <h3 className={`font-display text-3xl sm:text-4xl leading-tight ${wide ? "text-[#F4EEE3]" : "text-[#0A192F]"}`}>{s.title}</h3>
            <p className={`mt-3 max-w-md text-sm sm:text-base leading-relaxed ${wide ? "text-[#C9C3B6]" : "text-[#4A5468]"}`}>{s.short}</p>
          </div>
        </div>
        <motion.span className="pointer-events-none absolute bottom-0 left-0 h-[3px] w-full origin-left scale-x-0 bg-[#C5A059] transition-transform duration-700 group-hover:scale-x-100" />
      </Link>
    </FadeUp>
  );
};

export const ServicesBento = () => (
  <section className="paper pb-24 sm:pb-36" data-testid="home-services-bento">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 border-t border-[#0A192F]/15 pt-16">
        <div>
          <Eyebrow>Core services</Eyebrow>
          <h2 className="mt-6 font-display text-[#0A192F] text-4xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
            <MaskedLines inView delay={0} lines={["Six disciplines,", <span className="italic text-[#8A6A2B]">one window.</span>]} />
          </h2>
        </div>
        <Link to="/services" data-testid="bento-all-services-link" className="self-start lg:self-end inline-flex items-center gap-2 text-[#0A192F] border-b border-[#8A6A2B] pb-1">All services <ArrowUpRight className="h-4 w-4" /></Link>
      </div>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-5">
        {SERVICES.map((s, i) => (
          <div key={s.slug} className={`${SPANS[i]} ${i === 5 ? "md:col-span-2" : ""}`}>
            <Card s={s} i={i} />
          </div>
        ))}
      </div>
    </div>
  </section>
);
